export default "__VITE_ASSET__CjDYboxZ__"